import _styled from "styled-components";
var _class, _SatelliteImageryTimeFilterSection;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import { Component } from "react";
import defined from "terriajs-cesium/Source/Core/defined";
import Ellipsoid from "terriajs-cesium/Source/Core/Ellipsoid";
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import MapInteractionMode from "../../../Models/MapInteractionMode";
import Loader from "../../Loader";
import LocationItem from "../../LocationItem.jsx";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { runInAction, reaction } from "mobx";
import Styles from "./satellite-imagery-time-filter-section.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let SatelliteImageryTimeFilterSection = observer(_class = (_SatelliteImageryTimeFilterSection = class SatelliteImageryTimeFilterSection extends Component {
  removeFilter() {
    this.props.item.removeTimeFilterFeature();
  }
  zoomTo() {
    const feature = this.props.item.timeFilterFeature;
    const position = feature !== undefined && feature.position !== undefined ? feature.position.getValue(this.props.item.currentTime) : undefined;
    if (defined(position)) {
      const cartographic = Ellipsoid.WGS84.cartesianToCartographic(position);
      this.props.item.terria.currentViewer.zoomTo(new Rectangle(cartographic.longitude - 0.0005, cartographic.latitude - 0.0005, cartographic.longitude + 0.0005, cartographic.latitude + 0.0005));
    }
  }
  newLocation() {
    const {
      t
    } = this.props;
    // Cancel any feature picking already in progress.
    const terria = this.props.item.terria;
    const pickPointMode = new MapInteractionMode({
      message: t("satellite.pickPoint"),
      onCancel: () => runInAction(() => terria.mapInteractionModeStack.pop())
    });
    runInAction(() => terria.mapInteractionModeStack.push(pickPointMode));

    // Set up a reaction to observe pickedFeatures and filter the items
    // discrete times
    const disposer = reaction(() => pickPointMode.pickedFeatures, async pickedFeatures => {
      runInAction(() => {
        pickPointMode.customUi = function () {
          return /*#__PURE__*/_jsx(Loader, {
            message: t("satellite.querying")
          });
        };
      });
      await pickedFeatures.allFeaturesAvailablePromise;
      if (terria.mapInteractionModeStack[terria.mapInteractionModeStack.length - 1] !== pickPointMode) {
        // already cancelled
        disposer();
        return;
      }
      const item = this.props.item;
      const thisLayerFeature = pickedFeatures.features.filter(feature => {
        return item.mapItems.find(mapItem => {
          var _feature$imageryLayer;
          return mapItem.imageryProvider && mapItem.imageryProvider === ((_feature$imageryLayer = feature.imageryLayer) === null || _feature$imageryLayer === void 0 ? void 0 : _feature$imageryLayer.imageryProvider);
        }) !== undefined;
      })[0];
      if (thisLayerFeature !== undefined) {
        try {
          item.setTimeFilterFeature(thisLayerFeature, pickedFeatures.providerCoords);
        } catch (e) {
          terria.raiseErrorToUser(e);
        }
      }
      runInAction(() => terria.mapInteractionModeStack.pop());
      disposer();
    });
  }
  render() {
    if (!this.props.item.canFilterTimeByFeature) {
      return null;
    }
    const feature = this.props.item.timeFilterFeature;
    if (feature === undefined) {
      return this.renderNoFeatureSelected();
    } else {
      return this.renderFeatureSelected(feature);
    }
  }
  renderNoFeatureSelected() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: Styles.inactive,
      children: /*#__PURE__*/_jsx("div", {
        className: Styles.btnGroup,
        children: /*#__PURE__*/_jsx("button", {
          className: Styles.btn,
          onClick: () => this.newLocation(),
          children: t("satellite.filterByLocation")
        })
      })
    });
  }
  renderFeatureSelected(feature) {
    const {
      t
    } = this.props;
    // TODO: if the feature itself doesn't have a position, we should be able to use the position the user clicked on.
    const position = feature.position !== undefined ? feature.position.getValue(this.props.item.currentTime) : undefined;
    return /*#__PURE__*/_jsxs(_StyledDiv, {
      className: Styles.active,
      children: [/*#__PURE__*/_jsxs("div", {
        className: Styles.infoGroup,
        children: [/*#__PURE__*/_jsx("div", {
          children: t("satellite.infoGroup")
        }), /*#__PURE__*/_jsx(LocationItem, {
          position: position
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: Styles.btnGroup,
        children: [/*#__PURE__*/_jsx("button", {
          className: Styles.btn,
          onClick: () => this.removeFilter(),
          children: t("satellite.removeFilter")
        }), /*#__PURE__*/_jsx("button", {
          className: Styles.btn,
          onClick: () => this.zoomTo(),
          children: t("satellite.zoomTo")
        }), /*#__PURE__*/_jsx("button", {
          className: Styles.btn,
          onClick: () => this.newLocation(),
          children: t("satellite.newLocation")
        })]
      })]
    });
  }
}, _defineProperty(_SatelliteImageryTimeFilterSection, "propTypes", {
  item: PropTypes.object,
  t: PropTypes.func.isRequired
}), _SatelliteImageryTimeFilterSection)) || _class;
export default withTranslation()(SatelliteImageryTimeFilterSection);
var _StyledDiv = _styled("div").withConfig({
  displayName: "SatelliteImageryTimeFilterSection___StyledDiv",
  componentId: "sc-vzll1x-0"
})(["background:", ";"], p => p.theme.colorPrimary);